import { createReducer, createAction } from "redux-act";
import * as app from "./app";

const SAVE_LOCATION_FORM_REQUEST = `${
  app.NS
}location/save_location_form_request`;
export const SAVE_LOCATION_FORM_REQUEST_ACTION = createAction(
  SAVE_LOCATION_FORM_REQUEST
);
const SAVE_LOCATION_FORM_SUCCESS = `${
  app.NS
}location/save_location_form_success`;
export const SAVE_LOCATION_FORM_SUCCESS_ACTION = createAction(
  SAVE_LOCATION_FORM_SUCCESS
);
const SAVE_LOCATION_FORM_FAILURE = `${
  app.NS
}location/save_location_form_failure`;
export const SAVE_LOCATION_FORM_FAILURE_ACTION = createAction(
  SAVE_LOCATION_FORM_FAILURE
);

export const saveLocationFormRequest = id => {
  const action = SAVE_LOCATION_FORM_REQUEST_ACTION(id);
  return action;
};
export const saveLocationFormSuccess = location => {
  const action = SAVE_LOCATION_FORM_SUCCESS_ACTION(location);
  return action;
};

export const saveLocationFormFailure = error => {
  const action = SAVE_LOCATION_FORM_FAILURE_ACTION(error);
  return action;
};



// WEBPACK FOOTER //
// ./src/ducks/location.js